import { useState } from "react";
import { Link, useMatch, useResolvedPath } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import LinkToFile from "./LinkToFile";

export default function MainNavbar() {
  const { auth } = useAuth();
  const [isMenuCollapsed, setMenuCollapsed] = useState(true);
  const isLoggedIn = !!auth?.user;

  const handleToggleMenu = () => {
    setMenuCollapsed(!isMenuCollapsed);
  };

  return (
    <nav className="nav navbar-expand-md fixed-top">
      <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded={!isMenuCollapsed}
        aria-label="Toggle navigation"
        onClick={handleToggleMenu}
      >
        <span className="navbar-toggler-icon">תפריט</span>
      </button>
      <Link to="/">מערכת ניהול מכרזי עובדים</Link>
      <div
        className={`collapse navbar-collapse ${isMenuCollapsed ? "" : "show"}`}
        id="navbarNav"
        style={isMenuCollapsed ? {} : { backgroundColor: "rgba(0, 0, 0, 0.8)" }}
      >
        <ul className="navbar-nav">
          {auth?.roles?.includes("moamadeem") && (
            <CustomLink setMenuCollapsed={setMenuCollapsed} to="/moamadoiot">
              מועמדויות
            </CustomLink>
          )}
          {(auth?.roles?.includes("managers") ||
            auth?.roles?.includes("editors") ||
            auth?.roles?.includes("viewers")) && (
            <CustomLink setMenuCollapsed={setMenuCollapsed} to="/mekhrazeem">
              מכרזים
            </CustomLink>
          )}
          {(auth?.roles?.includes("managers") ||
            auth?.roles?.includes("editors") ||
            auth?.roles?.includes("ReviewMoamadeem")) && (
            <CustomLink
              setMenuCollapsed={setMenuCollapsed}
              to="/moamadootreview"
            >
              הצגת מועמדים
            </CustomLink>
          )}
          {(auth?.roles?.includes("managers") ||
            auth?.roles?.includes("editors") ||
            auth?.roles?.includes("viewers")) && (
            <CustomLink setMenuCollapsed={setMenuCollapsed} to="/reports">
              דו"חות
            </CustomLink>
          )}
          {(auth?.roles?.includes("managers") ||
            auth?.roles?.includes("editors")) && (
            <CustomLink setMenuCollapsed={setMenuCollapsed} to="/tables">
              טבלאות
            </CustomLink>
          )}
          {(auth?.roles?.includes("managers") ||
            auth?.roles?.includes("editors") ||
            auth?.roles?.includes("viewers")) && (
            <CustomLink setMenuCollapsed={setMenuCollapsed} to="/generalparams">
              הגדרות
            </CustomLink>
          )}
          {(auth?.roles?.includes("managers") ||
            auth?.roles?.includes("editors") ||
            auth?.roles?.includes("viewers")) && (
            <LinkToFile
              setMenuCollapsed={setMenuCollapsed}
              to="humanassets/human-assets003.pdf"
            >
              חוברת הנחיות מכרזים
            </LinkToFile>
          )}
        </ul>
        <ul className="mx-auto"></ul>
        <ul className="navbar-nav custom-ml-auto">
          {isLoggedIn ? (
            <span className="password-hint">{auth.user}</span>
          ) : (
            <CustomLink setMenuCollapsed={setMenuCollapsed} to="/register">
              רישום
            </CustomLink>
          )}

          <CustomLink setMenuCollapsed={setMenuCollapsed} to="/login">
            כניסה
          </CustomLink>
          <CustomLink setMenuCollapsed={setMenuCollapsed} to="/resetpassword">
            איפוס סיסמה
          </CustomLink>
          <CustomLink setMenuCollapsed={setMenuCollapsed} to="/logout">
            יציאה
          </CustomLink>
        </ul>
      </div>
    </nav>
  );
}

function CustomLink({ setMenuCollapsed, to, children, ...props }) {
  const resolvedPath = useResolvedPath(to);
  const isActive = useMatch({ path: resolvedPath.pathname, end: true });
  const handleMenuItemClick = () => {
    setMenuCollapsed(true);
  };
  return (
    <li className={isActive ? "active" : ""}>
      <Link to={to} onClick={handleMenuItemClick} {...props}>
        {children}
      </Link>
    </li>
  );
}
